<template>
  <va-create-layout>
    <farm-events-form :title="title" :item="item"></farm-events-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
